import { ReactComponent as Time } from 'src/assets/images/IconTime.svg'
import { ReactComponent as Address } from 'src/assets/images/IconDirectionSmall.svg'
import { ReactComponent as Phone } from 'src/assets/images/IconPhone.svg'
import { ReactComponent as Email } from 'src/assets/images/IconEmail.svg'
import { ReactComponent as Direction } from 'src/assets/images/IconDirection.svg'
import { ReactComponent as Calendar } from 'src/assets/images/IconCalendar.svg'


const icons = {
  time: <Time />,
  address: <Address />,
  phone: <Phone />,
  email: <Email />,
  direction: <Direction />,
  calendar: <Calendar />,
}

export const Icon = (props) => {
  return <span {...props}>{icons[props.name]}</span>
}
